import React from "react";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { theme } from "../Theme/index";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from '../Components/Partials/Navbar/Navbar';
import Dashboard from '../Pages/Dashboard/Dashboard';
import MarketDynamics from '../Pages/MarketDynamics/MarketDynamics';
import SmartSimulator from '../Pages/SmartSimulator/SmartSimulator';
import PricingAndArchitecture from '../Pages/PricingAndArchitecture/PricingAndArchitecture';
import TradeManagement from '../Pages/TradeManagement/TradeManagement';
import StatisticsTest from '../Pages/StatisticsTest/StatisticsTest';
import Login from "../Pages/Login/Login";
import RequireAuth from "../Utils/RequireAuth";
import UserProjectSelection from "../Pages/Login/UserProjectSelection";
import UploadExcel from "../Pages/Login/UploadExcel";
import ChangePassword from "../Pages/Login/ChangePassword";
// Redux imports
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setUserProject } from '../Redux/userPojectSlice/userProjectSlice';
import Scenarionew from 'src/Pages/ScenarioBuilder/Scenario';
import Optimization from 'src/Pages/Optimization/Optimization';
import AuthRedirect from "../Utils/AuthRedirect"; // Import this
import GapsAndOppotunity from 'src/Pages/GapsAndSolutions/GapsAndOpp';
import ChatEngine from 'src/Pages/ChatEngine/ChatEngine';
import Assortment from 'src/Pages/Assortment/Assortment';
import Canvas from "src/Pages/Canvas/Canvas";
import Promotion from 'src/Pages/Promo/Promo';
import EditCategory from 'src/Pages/Login/EditCategory';
import RequireToken from "../Utils/RequireToken";
import DataCenterHub from "src/Pages/DataCenterHub/DataCenterHub";
import PromoSimulator from "src/Pages/PromoSimulator/index";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Check local storage for user data
    const savedUserId = localStorage.getItem('userId');
    const savedProjectId = localStorage.getItem('projectId');
  
    console.log('Local storage values:', {
      savedUserId,
      savedProjectId,
    }); // Debugging
  
    if (savedUserId && savedProjectId) {
      // Dispatch user and project details to Redux
      dispatch(setUserProject({ userId: savedUserId, projectId: parseInt(savedProjectId, 10) }));
    } else {
      console.warn("User ID or Project ID missing in local storage.");
    }
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
            <BrowserRouter>
              <Routes>
                {/* Public Route */}
                {/* <Route path="/login" element={<Login />} /> */}
                <Route
        path="/login"
        element={
          <AuthRedirect>
            <Login />
          </AuthRedirect>
        }
      />
          <Route path="/select-user-id" element={<UserProjectSelection />} />
          <Route path="/upload-excel" element={<UploadExcel />} />
          <Route path="/category-edit" element={<EditCategory/>} />
          <Route
            path="/change-password"
            element={
              <RequireToken>
                <ChangePassword />
              </RequireToken>
            }
          />
          {/* Protected Routes */}
          <Route
            element={
              <RequireAuth>
                <Navbar />
              </RequireAuth>
            }
          >
            
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/market-dynamics" element={<MarketDynamics />} />
            <Route path="/smart-simulator" element={<SmartSimulator />} />
            <Route path="/gaps-solution" element={<GapsAndOppotunity />} />
            <Route path="/pricing-architecture" element={<PricingAndArchitecture />} />
            <Route path="/promotion-visibility" element={<Promotion />} />
            <Route path="/assortment" element = {<Assortment/>} />
            <Route path="/trade-management" element={<TradeManagement />} />
            <Route path="/canvas" element={<Canvas />} />
            <Route path="/statistics-test" element={<StatisticsTest />} />
            <Route path="/scenario-builder" element={<Scenarionew />} />
            <Route path="/optimization" element={<Optimization/>} />
            <Route path="/AI-Assistant" element={<ChatEngine/>} />
            <Route path="/promo-temp" element={<Promotion/>} />
            <Route path="/data-center-hub" element={<DataCenterHub />} />
            <Route path="/promo-simulator" element={<PromoSimulator />} />

          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
